module.exports = __webpack_public_path__ + "static/img/is_need_smt_3.5af45283.png";